//# sourceMappingURL=init.mjs.map
/// <reference types="./init.d.mts" />
import * as $auth from "../../altar/altar/auth.mjs";
import * as $auth0 from "../../auth0_client/auth0/client.mjs";
import * as $bool from "../../gleam_stdlib/gleam/bool.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import { None } from "../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import * as $modem from "../../modem/modem.mjs";
import * as $effect from "../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $msg from "../data/msg.mjs";
import * as $route from "../data/route.mjs";
import * as $store from "../data/store.mjs";
import { toList } from "../gleam.mjs";

export function flags() {
  return $result.map(
    $modem.initial_uri(),
    (uri) => {
      let initial_route = $route.from_uri(uri);
      let organization = $route.org_from_uri(uri);
      let auth0_client = $auth.client(new $auth.Authentication());
      return [initial_route, organization, auth0_client];
    },
  );
}

/**
 * Back to the login screen once the refresh token is gone: nothing can be
 * fetched anymore. Every failing call reports it, so only the first one acts.
 * 
 * @ignore
 */
function on_session_expired(client) {
  return $effect.from(
    (dispatch, get_state) => {
      return $auth0.on_session_expired(
        client,
        () => {
          let store = get_state();
          return $bool.guard(
            $option.is_none(store.user),
            undefined,
            () => {
              let $ = dispatch(new $msg.AuthStateChanged(new None()));
              
              return undefined;
            },
          );
        },
      );
    },
  );
}

function state_changed(user) {
  return $effect.from(
    (dispatch, _) => {
      let _pipe = user;
      let _pipe$1 = new $msg.AuthStateChanged(_pipe);
      return dispatch(_pipe$1);
    },
  );
}

export function init(flags) {
  let route = flags[0];
  let organization = flags[1];
  let client = flags[2];
  let _block;
  let _pipe = $store.new$(client, route);
  _block = $store.set_organization(_pipe, organization);
  let state = _block;
  return [
    state,
    $effect.batch(
      toList([
        $auth0.init(client, state_changed),
        on_session_expired(client),
        $modem.init(
          (var0) => { return new $msg.ApplicationChangedRoute(var0); },
        ),
      ]),
    ),
  ];
}
